import { EntityLayout } from '@backstage/plugin-catalog';
import { ReactNode } from 'react';

export const EntityLayoutWrapper = (props: { children?: ReactNode }) => {
  return (
    <>
      <EntityLayout>{props.children}</EntityLayout>
    </>
  );
};
